import { ReferralType } from '@wix/da-bi/pkg/constants';
import { ModuleName } from '../../types/modules';

export const moduleTypeToReferralType = (moduleType: ModuleName | null) => {
  switch (moduleType) {
    case 'papiCustombox':
      return ReferralType.CUSTOM_BOX;
    case 'userstats':
      return ReferralType.USER_STATS;
    default:
      return undefined;
  }
};
